import React from 'react';
import ReactDOM from 'react-dom/client';
import { SessionExpiryModal } from '../components/SessionExpiryModal';

let modalRoot = null;

export const showSessionExpiryModal = ({ onExtend, onCancel }) => {
  // Create modal container if it doesn't exist
  if (!document.getElementById('session-expiry-modal-root')) {
    const div = document.createElement('div');
    div.id = 'session-expiry-modal-root';
    document.body.appendChild(div);
  }
  
  const modalContainer = document.getElementById('session-expiry-modal-root');
  
  if (!modalRoot) {
    modalRoot = ReactDOM.createRoot(modalContainer);
  }
  
  const expiry = localStorage.getItem('peart_auth_token_expiry');
  const expiryTime = expiry ? parseInt(expiry) : Date.now();
  
  const handleClose = () => {
    if (modalRoot) {
      modalRoot.render(null);
    }
    if (onCancel) onCancel();
  };
  
  const handleExtend = async () => {
    try {
      if (onExtend) {
        await onExtend();
      }
      // Close modal after successful extension
      if (modalRoot) {
        modalRoot.render(null);
      }
    } catch (error) {
      console.error('Failed to extend session:', error);
      alert('Fehler beim Verlängern der Sitzung. Bitte melden Sie sich erneut an.');
      handleClose();
    }
  };
  
  modalRoot.render(
    React.createElement(SessionExpiryModal, {
      isOpen: true,
      onClose: handleClose,
      onExtend: handleExtend,
      expiryTime: expiryTime
    })
  );
};

export const closeSessionExpiryModal = () => {
  if (modalRoot) {
    modalRoot.render(null);
  }
};